import gql from 'graphql-tag';
import shortid from 'shortid';
import userAgentParser from 'ua-parser-js';
import packageInfo from '../../package.json';
import { useLocation, useParams } from 'react-router';
import { useEffect } from 'react';
import client from '../apollo';

const APP_ID_KEY = 'cinuru:appid';
export let appId = localStorage.getItem(APP_ID_KEY);
if (!appId) {
	appId = shortid.generate();
	localStorage.setItem(APP_ID_KEY, appId);
}

export const session = shortid.generate();

export const appVersion = `v${packageInfo.version}`;

const { browser, os } = userAgentParser(navigator.userAgent);
const { width, height } = window.screen;
export const device = [
	`${browser.name} ${browser.version}`,
	`(${os.name} ${os.version})`,
	`${width}x${height}`,
].join(' ');

const options = { appVersion, appId, device, session, source: 'DASHBOARD' };

export const log = async ({ type, value }) => {
	if (process.env.NODE_ENV !== 'production') return console.log('| logging', type, value);
	const datetime = new Date().toISOString();
	const logItem = { type, value: value ? JSON.stringify(value) : null, datetime };
	// save events to backend
	await client.mutate({
		mutation: gql`
			mutation logAnalyticsItems($items: [LogItem], $options: LogOptions) {
				logItems(items: $items, options: $options) {
					success
				}
			}
		`,
		variables: { items: [logItem], options },
		errorPolicy: 'all',
	});
};

let lastLink;

export const useOnRouteEnter: (routeName: string) => void = (routeName: string) => {
	const params = useParams();
	const location = useLocation();

	useEffect(() => {
		const link = location.pathname + location.search + location.hash;
		// only log if route has changed
		if (link !== lastLink) {
			lastLink = link;

			// log screen view
			log({ type: 'SCREEN_VIEWED', value: { key: routeName, params, link } });
		}
	}, [params, routeName]);
};
